"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "About", {
  enumerable: true,
  get: function get() {
    return _About["default"];
  }
});
Object.defineProperty(exports, "AdminRoutes", {
  enumerable: true,
  get: function get() {
    return _AdminRoutes["default"];
  }
});
Object.defineProperty(exports, "BuilderBlock", {
  enumerable: true,
  get: function get() {
    return _BuilderBlock["default"];
  }
});
Object.defineProperty(exports, "ClientReports", {
  enumerable: true,
  get: function get() {
    return _ClientReports["default"];
  }
});
Object.defineProperty(exports, "Confetti", {
  enumerable: true,
  get: function get() {
    return _Confetti["default"];
  }
});
Object.defineProperty(exports, "Dashboard", {
  enumerable: true,
  get: function get() {
    return _Dashboard["default"];
  }
});
Object.defineProperty(exports, "DataEntry", {
  enumerable: true,
  get: function get() {
    return _DataEntry["default"];
  }
});
Object.defineProperty(exports, "Form", {
  enumerable: true,
  get: function get() {
    return _FormWrapper["default"];
  }
});
Object.defineProperty(exports, "Gui", {
  enumerable: true,
  get: function get() {
    return _Gui["default"];
  }
});
Object.defineProperty(exports, "Help", {
  enumerable: true,
  get: function get() {
    return _Help["default"];
  }
});
Object.defineProperty(exports, "Laravel", {
  enumerable: true,
  get: function get() {
    return _Laravel["default"];
  }
});
Object.defineProperty(exports, "Logs", {
  enumerable: true,
  get: function get() {
    return _Logs["default"];
  }
});
Object.defineProperty(exports, "Manage", {
  enumerable: true,
  get: function get() {
    return _Manage["default"];
  }
});
Object.defineProperty(exports, "Nav", {
  enumerable: true,
  get: function get() {
    return _NavBar["default"];
  }
});
Object.defineProperty(exports, "ReportWrapper", {
  enumerable: true,
  get: function get() {
    return _ReportWrapper["default"];
  }
});
Object.defineProperty(exports, "RosteringContainer", {
  enumerable: true,
  get: function get() {
    return _RosteringContainer["default"];
  }
});
Object.defineProperty(exports, "SessionTabWrapper", {
  enumerable: true,
  get: function get() {
    return _SessionTabWrapper["default"];
  }
});
Object.defineProperty(exports, "TableViewer", {
  enumerable: true,
  get: function get() {
    return _TableViewer["default"];
  }
});
Object.defineProperty(exports, "allChildrenComplete", {
  enumerable: true,
  get: function get() {
    return _allChildrenComplete["default"];
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Root["default"];
  }
});
Object.defineProperty(exports, "displayFieldsHelper", {
  enumerable: true,
  get: function get() {
    return _displayFieldsHelper["default"];
  }
});
Object.defineProperty(exports, "findNav", {
  enumerable: true,
  get: function get() {
    return _findNav["default"];
  }
});
Object.defineProperty(exports, "queryVariablesHelper", {
  enumerable: true,
  get: function get() {
    return _queryVariablesHelper["default"];
  }
});
Object.defineProperty(exports, "reportTemplateBuilder", {
  enumerable: true,
  get: function get() {
    return _reportTemplateBuilder["default"];
  }
});
Object.defineProperty(exports, "reportTemplatePlayer", {
  enumerable: true,
  get: function get() {
    return _reportTemplatePlayer["default"];
  }
});
Object.defineProperty(exports, "setAppdefEnumFilterSettings", {
  enumerable: true,
  get: function get() {
    return _setAppdefEnumFilterSettings["default"];
  }
});
Object.defineProperty(exports, "widgetBuilder", {
  enumerable: true,
  get: function get() {
    return _widgetBuilder["default"];
  }
});
var _reportTemplateBuilder = _interopRequireDefault(require("./components/reportTemplateBuilder"));
var _reportTemplatePlayer = _interopRequireDefault(require("./components/reportTemplatePlayer"));
var _widgetBuilder = _interopRequireDefault(require("./components/widgetBuilder"));
var _BuilderBlock = _interopRequireDefault(require("./components/BuilderBlock"));
var _RosteringContainer = _interopRequireDefault(require("./components/RosteringContainer"));
var _FormWrapper = _interopRequireDefault(require("./components/FormWrapper"));
var _NavBar = _interopRequireDefault(require("./components/NavBar"));
var _findNav = _interopRequireDefault(require("./helpers/findNav"));
var _displayFieldsHelper = _interopRequireDefault(require("./helpers/displayFieldsHelper.js"));
var _queryVariablesHelper = _interopRequireDefault(require("./helpers/queryVariablesHelper.js"));
var _allChildrenComplete = _interopRequireDefault(require("./helpers/allChildrenComplete.js"));
var _setAppdefEnumFilterSettings = _interopRequireDefault(require("./helpers/setAppdefEnumFilterSettings.js"));
var _SessionTabWrapper = _interopRequireDefault(require("./components/DataEntry/SessionTabWrapper.js"));
var _ReportWrapper = _interopRequireDefault(require("./components/ReportWrapper"));
var _Dashboard = _interopRequireDefault(require("./components/PageComponents/Dashboard.js"));
var _Manage = _interopRequireDefault(require("./components/PageComponents/Manage.js"));
var _DataEntry = _interopRequireDefault(require("./components/PageComponents/DataEntry.js"));
var _ClientReports = _interopRequireDefault(require("./components/PageComponents/ClientReports.js"));
var _Confetti = _interopRequireDefault(require("./components/Confetti"));
var _AdminRoutes = _interopRequireDefault(require("./components/AdminRoutes"));
var _TableViewer = _interopRequireDefault(require("./components/TableViewer"));
var _About = _interopRequireDefault(require("./pages/About"));
var _Gui = _interopRequireDefault(require("./pages/Gui"));
var _Help = _interopRequireDefault(require("./pages/Help"));
var _Laravel = _interopRequireDefault(require("./pages/Laravel"));
var _Logs = _interopRequireDefault(require("./pages/Logs"));
var _Root = _interopRequireDefault(require("./Root.js"));
var _reducer = _interopRequireDefault(require("./reducer.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// Public components

// it has to be below exports, otherwise circular dependencies cause import/export problems

// Inject flow reducer
var store = window.cccisd && window.cccisd.store;
if (store) {
  if (!store.getState().appdefs) {
    store.injectReducer('appdefs', _reducer["default"]);
  }
} else {
  console.error('There is no redux store at window.cccisd');
}